import * as Constants from '../../Pages/Constants';
import { withStyles } from '@material-ui/core';
import { useCallback } from 'react';
import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Range, getTrackBackground } from 'react-range';
import PostDataController from '../../Controller/PostDataController.js';

const MDASIForm = (props) => {

  const { classes } = props;
  const [step, setStep] = useState(0);
  const optionsLabels = ["severity", "impact"];
  const [optionSelected, setOptionSelected] = useState(["0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0","0"]);
  const [message, setMessage] = useState("");

  const sendingForm = async () => {
    let to_send = [{label: "severity_one", value:0}, {label:"severity_two", value:0}, {label:"severity_three", value:0}, {label:"severity_four", value:0}, {label:"severity_five", value:0}, {label:"severity_six", value:0}, {label:"severity_seven", value:0}, {label:"severity_height", value:0}, {label:"severity_nine", value:0}, {label:"severity_ten", value:0}, {label:"severity_eleven", value:0}, {label:"severity_twelve", value:0}, {label:"severity_thirteen", value:0}, {label:"impact_one", value:0}, {label:"impact_two", value:0}, {label:"impact_three", value:0}, {label:"impact_four", value:0}, {label:"impact_five", value:0}, {label:"impact_six", value:0}, {label:"registered_by", value:0}]

    let index = 0
    to_send.forEach(obj => {
      to_send[index].value = parseInt(optionSelected[index])
      index++
    })
    to_send.unshift({label: "form_type", value:"MDASI"});                                   // add form_type on index 0
    index = to_send.findIndex(result => result.label === "registered_by")
    to_send[index].value = props.accountInformation.username;

    let current_Date = new Date()                                                                         // Get current date      
    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient);    // Send data in backend
    await props.update(current_Date, to_send, props.BannerDisplayedAlerts);                                             // update display
    props.cancelPopup();
  }

  const changeStep = (direction) => {
    if (direction === "next") {
        if (step === optionsLabels.length-1) {
          sendingForm()
        }
        else {
          setMessage("");
          setStep(step+1);
        }
      }
    else if (direction === "previous") {
      setMessage("");
      setStep(step-1);
    }
  }

  //Function to change the color of the pain scale
  const getPainColor = (i) => {
      let ret = "#548BF4"
      if (i == 0)
      {
          ret = "#548BF4"
      }
      else if (i > 0 && i < 4)
      {
          ret = "#93be2f"
      }
      else if (i > 3 && i < 6)
      {
          ret = "#f3f322"
      }
      else if (i > 5 && i < 8)
      {
          ret = "#ff7f00"
      }
      else
      {
          ret = "#d20100"
      }
      return (ret)
  }

  const movePainLevel = (values, i) => {
    let newOptionSelected = [...optionSelected]
    newOptionSelected[i] = values[0]
    setOptionSelected(newOptionSelected)
  }

  const generateScale = (i) => {
    return (
      <div
        style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            margin: 0,
            alignItems: "center"
        }}
      >
        <Range
          values={[optionSelected[i]]}
          step={1}
          min={0}
          max={10}
          onChange={(values) => movePainLevel(values, i)}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: "36px",
                display: "flex",
                width: "100%"
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: "5px",
                  width: "100%",
                  borderRadius: "4px",
                  background: getTrackBackground({
                    values: [optionSelected[i]],
                    colors: [getPainColor(optionSelected[i]), "#ccc"], //change the first to change the left part of the bar
                    min: 0,
                    max: 10
                  }),
                  alignSelf: "center"
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props, isDragged }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: "30px",
                width: "30px",
                borderRadius: "4px",
                backgroundColor: "#FFF", //color of the button
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                boxShadow: "0px 2px 6px #AAA"
              }}
            >
              <div
                style={{
                  justifyContent: "left",
                  alignItems: "center",
                  height: "22px",
                  width: "20px"
                }}
              >
              {optionSelected[i]}
              </div>
            </div>
          )}
        />
      </div>
    )
  }

  const generatePageSeverity = () => {
    const lignes = [
      <FormattedMessage id="mdasi.form.severity.one" defaultMessage="The most intense pain?"/>,
      <FormattedMessage id="mdasi.form.severity.two" defaultMessage="The most important fatigue?"/>,
      <FormattedMessage id="mdasi.form.severity.three" defaultMessage="The most severe nausea?"/>,
      <FormattedMessage id="mdasi.form.severity.four" defaultMessage="Sleep disorders?"/>,
      <FormattedMessage id="mdasi.form.severity.five" defaultMessage="The degree of concern?"/>,
      <FormattedMessage id="mdasi.form.severity.six" defaultMessage="The most marked breathlessness?"/>,
      <FormattedMessage id="mdasi.form.severity.seven" defaultMessage="The importance of memory loss?"/>,
      <FormattedMessage id="mdasi.form.severity.eight" defaultMessage="How important is loss of appetite?"/>,
      <FormattedMessage id="mdasi.form.severity.nine" defaultMessage="The importance of drowsiness?"/>,
      <FormattedMessage id="mdasi.form.severity.ten" defaultMessage="The importance of dry mouth?"/>,
      <FormattedMessage id="mdasi.form.severity.eleven" defaultMessage="The degree of sadness?"/>,
      <FormattedMessage id="mdasi.form.severity.twelve" defaultMessage="The importance of vomiting?"/>,
      <FormattedMessage id="mdasi.form.severity.thirteen" defaultMessage="How important are sensations of numbness or tingling?"/>,
    ];

    let scaleWidth = "40%"
    if (props.screenSize.width < 800) {
      scaleWidth = "90%"
    }
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="mdasi.form.severity.title" defaultMessage="1st Part : How serious are the symptoms?"/>
        </Row>
        <Row style={{ fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="mdasi.form.severity.details" defaultMessage="Some illnesses or treatments cause symptoms. We ask you to rate the importance of these if you have experienced them in the last 24 hours. For each question below, fill in a circle from 0 (no symptoms) to 10 (worst imaginable)."/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {lignes.map((ligne, i) => (
        <div>
            <Row style={{width:"100%", color: "black", alignItems: "center"}}>
              <Col xs={13}>
              <div style={{textAlign: 'left'}}>
                  {i+1}. {ligne}
              </div>
            </Col>
            </Row>
            <Row style={{width:"100%", color: "black", alignItems: "center"}}>
                <Col style={{width:scaleWidth, marginLeft: "20px"}}>
                  {generateScale(i)}
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePageImpact = () => {
    const lignes = [
      <FormattedMessage id="mdasi.form.impact.one" defaultMessage="General activity?"/>,
      <FormattedMessage id="mdasi.form.impact.two" defaultMessage="Mood?"/>,
      <FormattedMessage id="mdasi.form.impact.three" defaultMessage="Work (including housework)?"/>,
      <FormattedMessage id="mdasi.form.impact.four" defaultMessage="Relationships with others?"/>,
      <FormattedMessage id="mdasi.form.impact.five" defaultMessage="Walking ability?"/>,
      <FormattedMessage id="mdasi.form.impact.six" defaultMessage="The spirit?"/>,
    ];

    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="mdasi.form.impact.title" defaultMessage="Part 2: What impact have these symptoms had on your life?"/>
        </Row>
        <Row style={{ fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="mdasi.form.impact.details" defaultMessage="These symptoms often affect our sensations and activities. To what extent have these symptoms affected the following in the last 24 hours? For each item below, draw a circle from 0 (symptoms haven't affected anything) to 10 (symptoms have affected everything)."/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {lignes.map((ligne, i) => (
        <div>
            <Row style={{width:"100%", color: "black", alignItems: "center"}}>
              <Col>
              <div style={{textAlign: 'left'}}>
                  {i+1}. {ligne}
              </div>
            </Col>
            </Row>
            <Row style={{width:"100%", color: "black", alignItems: "center"}}>
              <Col xs={9}>
                {generateScale(13+i)}
            </Col>
          </Row>
        </div>
        ))}
      </div>
    )
  }

  const generatePage = () => {
    switch(step) {
    case 0 :
      return (generatePageSeverity())
    case 1 :
      return (generatePageImpact())
    default :
      return (null);
    }
  }

  const generateStep = () => {
    return (
      <div>
        <Row style={{ display: 'flex', justifyContent: 'center', fontWeight: "bold", fontSize:"2.2em", color: "black"}}>
            <FormattedMessage id="mdasi.form.title.main" defaultMessage="Health Questionnaire"/>
        </Row>
        <br/>
        <Row style={{ color: "black"}}>
          <FormattedMessage id="eq5d.form.instruction.page" defaultMessage="Please select the ONE box that best describes your health TODAY."/>
        </Row>
        <br/>
        {generatePage()}
        <br/>
        <Button
          disabled={step===0}
          variant="contained"
          color="default"
          startIcon={<ArrowBackIcon />}
           onClick={() => changeStep("previous")}
        >
          <FormattedMessage id="eq5d.form.arrow.previous" defaultMessage="Previous"/>
        </Button>
        <Button
          variant="contained"
          color="default"
          startIcon={<ArrowForwardIcon />}
           onClick={() => changeStep("next")}
        >
          <FormattedMessage id="eq5d.form.arrow.next" defaultMessage="Next"/>
        </Button>
      </div>
    )
  }

  let generalFormWidth = "75%"
  let generalFormPadding = 30
  if (props.screenSize.width < 800) {
    generalFormPadding = 3
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width:{generalFormWidth}, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px", padding: generalFormPadding}}>
          {generateStep()}
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        </div>
      </div>
    </div>
  );

}
export default withStyles(Constants.styles)(MDASIForm);
